module.exports = __webpack_public_path__ + "img/compliance-document.48bf9e97.svg";